import React from "react";
import { UIOrderInfoSection, UISelectFieldTable, UITableWithPagination, UIOrderDetails } from "../../../components/guiElements";
import { InputSection } from "../../../components/utilities";
import WarehouseFiltersView from "./WarehouseFilters";
import WarehouseOrderOptionsView from "./WarehouseOrderOptions";
import { orderByKeys } from "./orderByKeys";

function withConfiguration(Component) {
    function ConfiguredComponent({ config, ...runtimeProps }) {
        if (!config) {
            throw new Error("Configurazione componente warehouse mancante."
            );
        }

        if (config.enabled !== true) {
            return null;
        }

        return (
            <Component
                {...config.props}
                {...runtimeProps}
            />
        );
    }

    return ConfiguredComponent;
}

function WarehouseStockSelectionView({ headers = [], columnOrder = [], ...props }) {
    const orderedHeaders = orderByKeys( headers, columnOrder, header => header.field );

    return (
        <UISelectFieldTable
            {...props}
            headers={orderedHeaders}
        />
    );
}

function WarehouseTableView({ headers = [], columnOrder = [], loading = false, loadingMessage = "Caricamento dati...", ...props
}) {
    const orderedHeaders = orderByKeys(headers, columnOrder, header => header.field);

    if (loading) {
        return (
            <div
                className="warehouse-table-loading"
                role="status"
                aria-live="polite"
                aria-busy="true"
            >
                <div
                    className="preloader loading"
                    aria-hidden="true"
                >
                    {Array.from({ length: 6 }, (_, index) => (
                        <span className="slice" key={index} />
                    ))}
                </div>

                <span>{loadingMessage}</span>
            </div>
        );
    }

    return (
        <UITableWithPagination
            {...props}
            headers={orderedHeaders}
        />
    );
}

export const WarehouseOrderInfo = withConfiguration(UIOrderInfoSection);
export const WarehouseFilters = withConfiguration(WarehouseFiltersView);
export const WarehouseStockSelection = withConfiguration(WarehouseStockSelectionView);
export const WarehouseOrderOptions = withConfiguration(WarehouseOrderOptionsView);
export const WarehouseAddresses = withConfiguration(InputSection);
export const WarehouseTable = withConfiguration(WarehouseTableView);
export const WarehouseOrderDetails = withConfiguration(UIOrderDetails);